export const SUPER_ADMIN = 'super admin';
export const ADMIN = 'admin';
export const RECEPTIONIST = 'receptionist';
export const GUEST = 'guest';

